<template>
  <section class="apply-progress">
    <navigate-header hasBack="true" :title="navigateTitle" v-if="hasHeader" :navigateStyle="navigateStyle">
      <div slot="rightBtn" class="btn right-btn" v-if="showCancel" @click="cancelOrder">
        取消办理
      </div>
    </navigate-header>
    <minirefresh id="minirefresh"
                 class="apply-progress-refresh"
                 ref="minirefresh"
                 :options="options"
                 @pullingDown="onPullingDown">
      <div slot="content" class="apply-progress-swiper" :class="{'has-cancel': appChannel !== 'zhaohang' && showCancel}">
        <div class="progress-content-wrap" >
          <section class="apply-card">
            <div class="apply-info">
              <div class="plate-info">
                <i class="iconfont etc-icon-car"></i>
                <span>{{currentOrder.plate_no | plateNo('·')}}</span>
              </div>
              <div class="local-info">
                <i class="iconfont etc-icon-location"></i>
                <div>
                  <p><span class="name">{{currentOrder.send_name}}</span> {{currentOrder.send_phone}}</p>
                  <p class="address">{{currentOrder.send_area}} {{currentOrder.send_address}}</p>
                </div>
              </div>
            </div>
            <!--<span class="modify-btn">修改地址</span>-->
            <!--<div class="service" @click="m_customService"><i color-primary class="iconfont etc-icon-kefu"></i></div>-->
          </section>
          <div class="progress-view">
            <header>
              办理进度
            </header>
            <!--<div class="progress-tip">目前申办人数较多，设备货源紧张，审核和发货会有一定的延迟，敬请谅解</div>-->
            <div class="progress">
              <p class="progress-title" :class="checkInfoStatus.titleCls">
                <i class="progress-icon" :class="checkInfoStatus.icon"></i>
                <span>{{checkInfoStatus.statusText}}</span>
              </p>
              <div class="progress-content has-line" :class="[checkInfoStatus.contentCls, checkInfoStatus.titleCls]">
                <div class="info">
                  <p v-for="(text, index) in checkInfoStatus.showContent" :key="index">
                    {{text}}
                  </p>
                </div>
              </div>
              <p class="progress-title" :class="expressStatus.titleCls">
                <i class="progress-icon"></i>
                <span>{{ expressStatus.title }}</span>
              </p>
              <div class="progress-content has-line" :class="expressStatus.titleCls" >
                <div class="info" v-if="currentOrderStatus < 3">
                  <p>3个工作日内完成配送</p>
                </div>
                <div class="info" v-else >
                  <div>
                    <span>{{ currentOrder.logisticOrder.logistic_company }} {{ currentOrder.logisticOrder.logistic_number }}</span>
                    <img @click="copyExpressageNum" class="copy-img" src="https://wecos.etczs.net/H5/copy-icon.png" />
                    </div>
                  <div @click="showAdd = !showAdd"  class="express-con" >
                    <span class="express" :class="showAdd ? 'show' : 'hide'">{{expressInfo.status}}</span>
                    <i class="iconfont etc-icon-arrow-right" :class="showAdd ? 'show' : 'hide'" v-if="expressInfo.showArrow"></i>
                  </div>
                </div>
              </div>
              <div class="progress-title unfinished">
                <i class="progress-icon"></i>
                <span>安装激活</span>
              </div>
              <div class="progress-content">
                <div class="info">
                  <div>收到设备后，请扫描说明书上的二维码，根据指引完善激活资料并激活设备。</div>
                  <div class="green">请确保安装车辆与办理车辆一致，否则将被列入高速黑名单</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </minirefresh>
    <div class="progress-bottom" >
      <template >
        <button cool-btn @click="tapNext" v-if="!isCancelLoding" :class="currentOrderStatus >= 3 ? '': 'disabled'">确认收货并激活</button>
        <button cool-btn disabled v-else >订单取消中</button>
        <div class="apply-bottom">
          <button class="cancel-btn" @click="m_customService">客服中心</button>

          <template v-if="showCancel && !isCancelLoding" >

            <div class="line"></div>
            <button class="cancel-btn" @click="cancelOrder">取消订单</button>
          </template>
        </div>
      </template>
      <div class="fixed-bottom"></div>
    </div>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
// store
import { mapState, mapMutations } from 'vuex'
// config
// import ETC from '@/config/etc.config'
// components
import NavigateHeader from '@/components/cool.navigateHeader'
import MiniRefresh from '@/components/minirefresh'
// api
import ApplyApi from '@/api/apply.api'
import reconApply from '@/api/reconApply.api'

// import NewApplyApi from '@/api/newApply.api'
// import UserApi from '@/api/user.api'
// util
import Util from '@/utils/util'

export default {
  name: 'applyProgress',
  mixins: [FunMixin, BiMixin],
  components: {
    minirefresh: MiniRefresh,
    NavigateHeader
  },
  data() {
    return {
      currentOrderStatus: '',
      showCancel: false,
      rejectStatus: '',
      options: {
        container: '#minirefresh',
        up: {
          isLock: true
        }
      },
      showAdd: false,
      isLoading: true,
      subNoticeData: '', // 物流特殊文案
      isCancelLoding: false, // 订单取消中
      expressInfo: '' // 快递信息
    }
  },
  computed: {
    // expressAddr() {
    //   return `${this.currentOrder.send_area || ''} ${this.currentOrder
    //     .send_address || ''}`
    // },
    expressStatus() {
      const status = this.currentOrderStatus || -100
      switch (status) {
        case 3:
          return {
            titleCls: 'processing',
            title: '设备已发货'
          }
        case 4:
          return {
            titleCls: 'success',
            title: '设备已签收'

          }
        default:
          return {
            titleCls: 'unfinished',
            title: '快递发货'
          }
      }
    },
    madeStatus() {
      const status = this.currentOrderStatus || -100
      switch (status) {
        case 20:
          return {
            titleCls: 'processing'
          }
        case 3:
        case 4:
          return {
            titleCls: 'success'
          }
        default:
          return {
            titleCls: 'unfinished'
          }
      }
    },
    checkInfoStatus() {
      // const status = this.currentOrderStatus || -100
      // let str = [this.subNoticeData];
      let str = ['办理资格审核，预计需要最多48小时'];
      if (!this.currentOrder.reviewOrder) {
        return {
          titleCls: 'processing',
          statusText: '资料审核中',
          // showContent
          showContent: str
        }
      }
      // this.currentOrder.review_order = this.currentOrder.reviewOrder || this.currentOrder.review_order
      // 新订单
      // `local_review_status` tinyint(4) NOT NULL DEFAULT '0' COMMENT '我方审核状态 1、待审核 2、审核通过、3、审核失败 4 无需审核',
      // `third_review_status` tinyint(4) NOT NULL DEFAULT '1' COMMENT '第三方审核状态 1、待推送 2、推送中 3、待审核 4、审核通过 5 审核失败',
      switch (true) {
        case +this.currentOrder.reviewOrder.local_review_status === 3 || +this.currentOrder.reviewOrder.third_review_status === 5 || (this.currentOrder.logisticOrder && this.currentOrder.logisticOrder.is_canceled):
          return {
            titleCls: 'warn',
            icon: 'iconfont etc-icon-warn',
            statusText: '激活资料审核失败',
            showContent: this.currentOrder && this.currentOrder.reject_msg ? [ ...this.currentOrder.reject_msg.split(';') ] : [ '' ]
          }
        case +this.currentOrder.reviewOrder.local_review_status === 1 || +this.currentOrder.reviewOrder.third_review_status < 4:
          return {
            titleCls: 'processing',
            statusText: '资料审核中',
            // showContent: ['排队审核中，预计1个工作日内完成']
            showContent: str
          }
        case (+this.currentOrder.reviewOrder.local_review_status === 2 || +this.currentOrder.reviewOrder.local_review_status === 4) && +this.currentOrder.reviewOrder.third_review_status === 4:
          return {
            titleCls: 'success',
            statusText: '激活资料审核通过',
            showContent: ['车辆可正常办理ETC']
          }
        default:
          return {
            titleCls: 'processing',
            // icon: 'icon processing',
            statusText: '资料审核中',
            // showContent
            showContent: str
          }
      }
    },
    ...mapState(['currentCard', 'currentOrder'])
  },
  methods: {
    copyExpressageNum() {
      Util.copy(this.currentOrder.logisticOrder.logistic_number, '快递单号已复制')
    },
    async onPullingDown() {
      console.log('pulling down and load data')
      try {
        await this.getOrder()
      } catch (e) {
      } finally {
        this.$refs.minirefresh.endDownLoading(true)
        this.$forceUpdate()
      }
    },
    async cancelOrder() {
      // 北京取消
      if (this.currentCard.issuer_id === 2) {
        const res = await this.m_showConfirm({
          content:
            '订单取消需发行方进行操作，预计需要等待2个工作日，是否仍取消订单？',
          confirmBtn: '确认取消',
          cancelBtn: '放弃'
        })
        if (!res) return
      }
      this.m_goPages('cancelOrder')
    },
    async applyAgain() {
      let params = { order_sn: this.currentOrder.order_sn }
      try {
        this.m_showLoading()
        if (this.rejectStatus === 2 || this.rejectStatus === 3) {
          await ApplyApi.resetStatus(params)
          this.m_replacePages('orderInfo')
        } else {
          await ApplyApi.cancelOrder(params)
          this.setUserApplyStep(0)
          this.setCurrentOrder(null)
          this.$router.back()
        }
      } catch (e) {
      } finally {
        this.m_loadingClose()
      }
    },
    async declareReceived() {
      await this.m_clickDebounce('declareReceived')
      try {
        this.m_showLoading()
        await reconApply.orderDeclareReceived({ order_sn: this.currentOrder.order_sn })
        this.setCurrentOrder({ declare_received: 1 })
        this.$forceUpdate()
      } finally {
        this.m_loadingClose()
      }
    },
    hidePopup() {
      this.$refs.popup.$emit('hidePopup')
    },
    tapNext() {
      if (this.currentOrderStatus < 3) return
      if (!this.currentOrder.declare_received) {
        // 确认收货
        this.m_showConfirm({
          title: '收货提示',
          content: '确认收到电子标签设备和ETC卡了吗？',
          confirmBtn: '确认收货',
          cancelBtn: '取消'
        })
          .then(res => {
            if (res) {
              this.declareReceived()
            }
          })
      } else {
      // 跳转激活引导
        this.m_goPages('paySuccess', {
          orderSn: this.currentOrder.order_sn,
          plateNo: this.currentOrder.plate_no
        })
      }
    },
    async getOrder() {
      // `status` int(10) unsigned NOT NULL DEFAULT '0' COMMENT '1、待支付 2 、待发货 3、待签收 4、已完成 5、已取消'

      const {order, reject_reason, step_list} = await reconApply.getApplyCurrentOrder({order_sn: this.currentOrder.order_sn})
      // 保存发卡方，卡信息

      this.setCurrentIssuer(order.card_issuer)
      this.setCurrentCard(order.card)
      this.setCurrentOrder({ reject_reason, ...order, step_list })
      this.currentOrderStatus = order.status
      // this.rejectStatus = this.handleRejectStatus()
      this.showCancel = !!~step_list.can_do.indexOf('CancelOrder')
      // 取消中订单状态判断
      const cancelOrder = order.cancelOrder
      // cancel_status 2 待取消 4 取消中 6 取消成功 8 取消失败
      // 是否需要显示取消中的状态
      this.isCancelLoding = !!(cancelOrder && ~[2, 4].indexOf(+cancelOrder.cancel_status))
      if (cancelOrder && ~[6, 8].indexOf(+cancelOrder.cancel_status)) {
        // 有取消结果了
        const isFail = +cancelOrder.cancel_status === 8

        this.m_showConfirm({
          title: isFail ? '订单取消失败' : '订单取消成功',
          content: +cancelOrder.show_reason ? cancelOrder.reason : (isFail ? '订单取消失败，当前服务器繁忙' : '订单已成功取消'),
          noCancel: true
        }).then(async res => {
          await reconApply.cancelStatusConfirm({
            order_sn: order.order_sn
          })
          if (isFail) {
            // 取消失败的订单恢复正常状态，重新请求订单信息
            this.getOrder()
          } else {
            // 取消成功的订单回到首页
            this.m_backHome()
          }
        })
      }
      if (order.status >= 3) {
        reconApply.orderExpressTrace()
          .then(res => {
            if (res) {
              this.expressInfo = res.list ? res.list[0] : {}
              this.expressInfo.showArrow = this.expressInfo.status.length > 24
            }
          })
      }
      this.$forceUpdate()
    },
    ...mapMutations([
      'setUserApplyStep',
      'setCurrentOrder',
      'setCurrentIssuer',
      'setCurrentCard'
    ])
  },
  async mounted() {
    this.m_showLoading()
    try {
      await this.getOrder()
    } catch (e) {
      this.showCancel = true
    } finally {
      this.m_loadingClose()
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../style/cool.practical';
.apply-progress {

  background: #F5F5F5;
  /*overflow: hidden;*/
  /*padding: 0 !important;*/
  height: 100vh;
  /*padding-bottom: 150px;*/
  /*&.has-cancel{
    padding-bottom: 220px;
  }*/
  &.has-header {
    .apply-progress-refresh {
      margin-top: 88px;
    }
  }
  // &.pahcz.has-header.iphone {
  //   .apply-progress-refresh {
  //     margin-top: calc(88px + 44px);
  //   }
  // }
  // &.pahcz.has-header.iphoneX {
  //   .apply-progress-refresh {
  //     margin-top: calc(88px + 58px);
  //   }
  // }
  .apply-progress-swiper {
    /*overflow-y: scroll;*/
    padding-bottom: 50px;
    &.has-cancel {
      padding-bottom: 70px;
    }
  }
  .progress-content-wrap {
    padding-top: 1px;
  }
  .apply-card {
    padding: 20px 40px 30px;
    @extend %flex-space-between;
    .apply-info {
      i {
        font-size: 34px;
        margin-right: 20px;
        color: #999999;
      }
      .plate-info {
        height: 40px;
        @extend %flex-center-start;
        span {
          font-size: 30px;
          font-weight: bold;
        }
      }
      .local-info {
        max-width: 467px;
        margin-top: 20px;
        display: flex;
        font-size: 24px;
        color: #666666;
        line-height: 40px;
        .etc-icon-location {
          margin-top: 22px;
        }
        .address {
          margin-top: 12px;
        }
      }
    }
    .modify-btn {
      font-size: 28px;
      color: #0094ee;
      flex-shrink: 0;
      margin-left: 30px;
    }
  }
  .progress-view {
    border-top: 20px solid #f5f5f5;
    padding: 30px 40px 50px;
    header {
      font-size: 32px;
      font-weight: bold;
    }
    .progress-tip {
      font-size: 24px;
      color: #666666;
      margin-top: 10px;
      padding-left: 24px;
    }
    .progress {
      /*padding: 0 30px;*/
      padding-left: 15px;
      @extend %apply-progress;
      .progress-title {
        font-size: 28px;
        height: 40px;
        line-height: 40px;
        .progress-icon {
          width: 32px;
          height: 32px;
          &.iconfont {
            font-size: 30px;
          }
        }
        [color-blue] {
          float: right;
        }
        &.processing,
        &.success {
          .progress-icon {
            background-color: $primary-color;
          }
        }
        &.unfinished {
          color: #999999;
          .progress-icon {
            background-color: #cccccc;
          }
        }
        &.warn {
          color: $red-tip-color;
          .progress-icon {
            color: $red-tip-color;
            box-sizing: content-box;
          }
        }
      }
      .progress-content {
        position: relative;
        padding-bottom: 20px;
        .info {
          p {
            /*margin-top: 10px;*/
            .copy-btn {
              margin-left: 20px;
            }
          }
          .etc-icon-arrow-right {
            font-size: 28px;
            margin-left: 10px;
          }
          .green {
            color: $primary-color;
          }
        }

        .copy-img {
          margin-left: 13px;
          width: 26px;
          height: 26px;
        }
        .express-con {
          display: flex;
          align-items: flex-start;
          .etc-icon-arrow-right {
            transform: rotate(90deg);
            &.show {
            transform: rotate(-90deg);
            }
          }
        }
        .express {
          width: 570px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 33px;
          max-height: 500px;
          transition: max-height .3s;
          &.hide {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-height: 33px;
          }
          &.show {

          }
        }
        &.wran {
          color: #333333;
        }
      }

      .has-line {
        &.success {
          &:before {
            background-color: $primary-color;
          }
        }
        &.unfinished,
        &.warn,
        &.processing {
          &:before {
            background-color: #dddddd;
          }
        }
      }
    }
  }
  .tip-view {
    border-top: 20px solid #f5f5f5;
    padding: 30px 40px;
    .tips {
      background-color: #eeeeee;
      opacity: 0.5;
      padding: 20px;
      .tip {
        font-size: 24px;
        color: #666666;
        line-height: 40px;
      }
    }
  }
  .progress-bottom {
    padding: 20px 55px 30px;
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    text-align: center;
    z-index: 10;
    background-color: #fff;
    .cancel-btn {
      color: #0094ee;
      font-size: 28px;
      line-height: 42px;
    }
    .apply-bottom {
      margin-top: 39px;
      display: flex;
      justify-content: center;
      align-items: center;
      .line {
        width: 2px;
        height: 28px;
        background: #DDDDDD;
        margin: 0 30px;
      }
    }
  }
  .received-popup {
    .popup-container {
      text-align: center;
      header {
        font-size: 38px;
        font-weight: bold;
        line-height: 54px;
        padding: 40px 0 30px;
      }
      .popup-content {
        font-size: 30px;
        line-height: 42px;
        color: #666666;
        img {
          width: 280px;
          height: auto;
          margin-top: 30px;
        }
        .tip {
          font-size: 22px;
          color: #999999;
          margin-top: 5px;
        }
      }
      .popup-footer {
        padding: 35px 60px 25px;
        .cancel-btn {
          font-size: 30px;
          line-height: 60px;
          margin-top: 20px;
          color: #999999;
        }
      }
    }
  }
}
</style>
